/**
 * 当天挂号相关路由
 */
export default [
  /**
   * 选择医院
   */
  {
    path: '/tbook/hos',
    meta: {
      title: '选择医院'
    },
    component: () => import('../pages/todayBook/hos')
  },

  /**
   * 选择医生
   * query
   * **** hosid
   * **** hosname
   * **** ksid
   * **** ksmc
   */
  {
    path: '/tbook/doct',
    component: () => import('../pages/todayBook/t-doct')
  },

  /**
   * 支付成功
   */
  {
    path: '/tbook/succeed',
    component: () => import('../pages/todayBook/t-succeed')
  }
]



// WEBPACK FOOTER //
// ./src/router/todayBook.js